// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"VO","reco":"WO","products":"XO"};